module.exports = __webpack_public_path__ + "img/logo-rise.db94c114.png";